<template>
  <div class="servicesWrap">
    <img :src="merchantInfo.img" alt="" style="width: 100%;height: 130px;object-fit: cover;margin-bottom: 20px">
    <h3 class="servicesTitle">项目预约</h3>
    <van-form @submit="onSubmit">
      <van-cell-group>
        <van-field v-model="form.phone" label="手机号" label-width="50"  placeholder="请输入手机号" />
        <van-field v-model="form.carMark" label="车牌号" label-width="50" placeholder="请输入车牌号" />
        <van-field v-model="form.carNo" label="车架号" label-width="50"  placeholder="请输入车架号" />
        <van-field v-if="service_type == 3" v-model="form.carNo" label="车身颜色" label-width="60"  placeholder="请输入车身颜色" />
        <van-field v-if="service_type == 4" v-model="form.carNo" label="上车地点" label-width="60"  placeholder="请输入上车地点" />
        <van-field v-if="service_type == 4" v-model="form.carNo" label="目的地" label-width="60"  placeholder="请输入目的地" />
        <van-field v-if="service_type == 1 || service_type == 5" v-model="form.currentKM" label="当前车辆行驶里程km" label-width="150"  placeholder="请输入里程" />
        <van-field v-if="service_type == 1" v-model="form.beforeKM" label="上次更换刹车的里程km" label-width="150"  placeholder="请输入里程" />
        <van-field v-if="service_type == 1" v-model="form.beforeKM" label="上次更换冷却液的里程km" label-width="180"  placeholder="请输入里程" />
        <van-field v-if="service_type == 1" v-model="form.beforeKM" label="上次清洗进气系统的里程km" label-width="180"  placeholder="请输入里程" />
        <van-field v-model="form.bookDate" is-link readonly name="picker" label="预约日期" placeholder="点击选择日期" @click="showPicker = true"/>
        <van-popup v-model:show="showPicker" position="bottom" title="预约日期">
          <van-datetime-picker type="datetime" :value="form.currentDate" :minDate="dateObj.minDate" :formatter="dateObj.formatter()" @confirm="onConfirm" @cancel="showPicker = false"/>
        </van-popup>
        <van-field v-if="service_type == 5" v-model="form.engine" is-link readonly name="picker" label="发动机类型" placeholder="点击选择发动机类型" @click="showEnginePicker = true"/>
        <van-popup v-if="service_type == 5" v-model:show="showEnginePicker" position="bottom" title="标题">
          <van-picker show-toolbar title="发动机类型" :columns="columns" @confirm="onEngineConfirm" @cancel="showEnginePicker = false"/>
        </van-popup>
        <van-field v-if="service_type == 5" v-model="form.boli" is-link readonly name="picker" label="玻璃类型" placeholder="点击选择玻璃类型" @click="showBoliPicker = true"/>
        <van-popup v-if="service_type == 5" v-model:show="showBoliPicker" position="bottom" title="标题">
          <van-picker show-toolbar title="玻璃类型" :columns="columnsBoli" @confirm="onBoliConfirm" @cancel="showBoliPicker = false"/>
        </van-popup>
        <van-field v-if="service_type == 1" v-model="form.remark" rows="4" autosize label="刹车/冷却/车辆系统现状描述" label-width="80" type="textarea" maxlength="200" placeholder="请输入内容" show-word-limit/>
        <van-field v-if="service_type == 3" v-model="form.remark" rows="4" autosize label="漆面损失情况" label-width="100" type="textarea" maxlength="200" placeholder="请输入内容" show-word-limit/>
        <van-field v-if="service_type == 5" v-model="form.remark" rows="4" autosize label="情况描述" label-width="100" type="textarea" maxlength="200" placeholder="请输入内容" show-word-limit/>
<!--        <van-field v-model="form.remark" rows="4" autosize label="刹车异常症状描述" label-width="120" type="textarea" maxlength="200" placeholder="请输入内容" show-word-limit/>-->
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button :loading="submitLoading" round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import {servicesNew} from "@/apis/rescue";
import services from "@/views/services/index.vue";



export default {
    data(){
        return {
            user_phone: localStorage.getItem('user_phone'),
            user_nick: localStorage.getItem('user_nick'),
            merchant_id: localStorage.getItem('merchant_id'),
            service_type: 1,
            form: {
              phone: "",
              carMark:"",
              carNo: "",
              currentKM: 0,
              beforeKM: 0,
              bookDate: "",
            },
            dateObj:{
              minHour: 10,
              maxHour: 20,
              minDate: new Date(),
              maxDate: new Date(2019, 10, 1),
              bookDate: new Date(),
              formatter(type, value) {
                if (type === 'year') {
                  return `${value}年`;
                }
                if (type === 'month') {
                  return `${value}月`;
                }
                return value;
              },
            },
            showPicker:false,
            showBoliPicker:false,
            showEnginePicker:false,
            submitLoading:false,
            serviceTypeObj:{
              1: 'wash'
            },
            merchantList:[
              {id: '1', img: '', name: '壳牌鹏致（园洲镇鑫宝驾）', address: '园洲镇沙河大道69号', desc: "标准洗车，精致洗车，空调清洗，车内消毒" },
              {id: '2', img: '', name: '嘉实多（跨粤汽车服务中心）', address: '麦地南路2号金裕大厦5号商铺', desc: "标准洗车，精致洗车，汽车美容，保养维修"  },
              {id: '3', img: '', name: '美孚1号车养护（惠州卓金冠店）', address: '麦地南路2号金裕大厦5号商铺', desc: "汽车服务、保养服务、汽车喷漆、钣金、"  },
              {id: '4', img: '', name: '京东养车（陈江大道店）', address: '惠城区陈江街道陈江大道学塘排(三)小区A4房1楼', desc: "洗车、汽车打蜡、保养服务、汽车维修"  },
              {id: '5', img: '', name: '漆遇车坊', address: '惠泽大道5号178', desc: "空调清洗、小保养、大保养、换机油、换刹车油，换刹车片、漆面修复"  },
              {id: '6', img: '', name: '车起点美容养护中心', address: ' 惠城区陈江街道陈江大道北36号宝德科技工业园东南方向150米', desc: "洗车服务、保养服务、维修服务、美容服务"  },
              {id: '7', img: '', name: '信义汽车玻璃（惠州仲恺店）', address: '五一路惠州汽配称D7-1号', desc: "汽车玻璃修复"  },
              {id: '8', img: '', name: '途虎养车工场店（惠州仲恺平南店）', address: '惠城区惠环街道和畅西3路43号', desc: "洗车服务、保养服务、维修服务、美容服务"  },
              {id: '9', img: '', name: '福耀汽车玻璃（惠州仲恺大道店）', address: '五一大道19号', desc: " 普洗、精洗、汽车玻璃修复、玻璃贴膜"  },
              {id: '10', img: '', name: '保来利汽车维修服务中心（仲恺店）', address: '惠城区惠环街道康平路康城四季花园三期21栋1-5号商铺', desc: "洗车服务、保养服务、维修服务、美容服务、改装服务、其他服务"  },
              // {id: '11', img: '', name: '', address: '', desc: "标准洗车，精致洗车，空调清洗，车内消毒"  },
              // {id: '12', img: '', name: '', address: '', desc: "标准洗车，精致洗车，空调清洗，车内消毒"  },
            ],
            merchantInfo:{
              id: '1',
              img: 'https://h5.tc-rescue.com/snServices/images/m (1).jpg',
              name: '壳牌鹏致（园洲镇鑫宝驾）',
              address: '园洲镇沙河大道69号',
              desc: "标准洗车，精致洗车，空调清洗，车内消毒"
            },
            columns:[
              { text: '汽油', value: '1' },
              { text: '柴油', value: '2' },
              { text: '混动', value: '3' },
              { text: '电动', value: '4' }
            ],
            columnsBoli:[
              { text: '前挡风', value: '1' },
              { text: '侧窗', value: '2' },
              { text: '后挡风', value: '3' },
              { text: '天窗', value: '4' }
            ]
        }
    },
    created(){
        this.service_type = this.$route.query.type;
    },
    mounted(){

    },
    methods: {
        onSubmit(){
            let that = this;
            let jsonData = {
              ...this.form
            }
            let data = {
                user_phone: this.user_phone,
                user_nick: this.user_nick,
                merchant_id: this.merchant_id,
                service_type: this.service_type,
                json_data: JSON.stringify(jsonData)
            }
            if(!jsonData.phone){
              this.$toast('请输入用户手机号！');
              return
            }
            if(!jsonData.bookDate){
              this.$toast('请选择预约时间！');
              return
            }

            this.submitLoading = true;
            servicesNew(data).then((res)=>{
                let resData = res.data.data;
                if(res.data.code == 1){
                  this.$router.push({path:'/servicesResult?id=' + resData.order_id})
                }else{
                  this.$toast(res.data.info? res.data.info:'系统错误');
                }
            })
        },
        dateInput(row){
            this.form.battery_date = row.text;
            this.showPicker = false;
        },
        onConfirm(row){
          this.form.bookDate = row.toLocaleString();
          this.showPicker = false;
        },
        onEngineConfirm(row){
          this.form.engine = row.text;
          this.showEnginePicker = false;
        },
        onBoliConfirm(row){
          this.form.boli = row.text;
          this.showBoliPicker = false;
        }
    }
}
</script>

<style lang='scss' scoped>

</style>
